// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'gear-nodes';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M11.52 12.912v5.664m-8.16 0V16.54c0-.68.384-1.132.96-1.132h14.4c.576 0 .96.453.96 1.132v2.036M11.52 22.8a2.112 2.112 0 1 0 0-4.224 2.112 2.112 0 0 0 0 4.224Zm8.16 0a2.112 2.112 0 1 0 0-4.224 2.112 2.112 0 0 0 0 4.224Zm-16.32 0a2.112 2.112 0 1 0 0-4.224 2.112 2.112 0 0 0 0 4.224Zm8.112-15.456a.192.192 0 0 1 0-.384m0 .384a.192.192 0 0 0 0-.384' />
    <path d='m12.624 2.064.384 1.248c.096.48.576.672 1.056.576l1.248-.288c1.152-.288 1.92 1.056 1.152 1.92l-.864.96c-.288.384-.288.864 0 1.152l.864.96c.768.864 0 2.208-1.152 1.92l-1.248-.288c-.48-.096-.864.192-1.056.576l-.384 1.248c-.384 1.152-1.92 1.152-2.208 0l-.384-1.248c-.096-.48-.576-.672-1.056-.576l-1.248.288c-1.152.288-1.92-1.056-1.152-1.92l.864-.96c.288-.384.288-.864 0-1.152l-.864-.96c-.768-.864 0-2.208 1.152-1.92l1.248.288c.48.096.864-.192 1.056-.576l.384-1.248c.288-1.152 1.824-1.152 2.208 0Z' />
  </g>
);

export const viewBox = '-1 -0.5 25 25';
